import React, { useEffect, useState } from "react";
import Layout from "../layouts/Layout";
import { connect } from "react-redux";
import { Container } from "react-bootstrap";

const Terms = ({ apiData, profile }) => {
  return (
    <Layout title={"Privacy Policy"}>
      <Container className="terms">
        <h2 className="mb-5">Privacy Policy</h2>
        <p>
          Open Bonnet FZCO is committed to protecting our visitors’ and members’
          privacy. The following Privacy Policy outlines the information Open
          Bonnet FZCO (the “Company”, “we”, or “us”) may collect and how we may
          use that information to better serve visitors and members while using
          our website{" "}
          <a href="https://www.openbonnet.com">www.openbonnet.com</a> or the
          Open Bonnet mobile application.
        </p>{" "}
        <p />{" "}
        <p>
          Please read this Privacy Policy carefully to understand our policies
          and practices regarding your information and how we will treat it. By
          accessing or using our website or mobile application (collectively,
          the Platform), you agree to the terms of this Privacy Policy. This
          Privacy Policy may change from time to time. Please review the
          following carefully so that you understand our privacy practices.
        </p>{" "}
        <p />{" "}
        <p>
          If you have questions about this Privacy Policy, please contact us at{" "}
          <a href="mailto:support@openbonnet.com">support@openbonnet.com</a>
        </p>{" "}
        <p />{" "}
        <p>
          <strong>Information We Collect</strong>
        </p>{" "}
        <p />{" "}
        <p>
          Upon registration with the Platform as a car owner, a user profile is
          developed to further customize the user’s experience. Currently the
          required data fields are:
        </p>{" "}
        <p />{" "}
        <ul>
          {" "}
          <li>
            – <strong>For account creation:</strong> Name, Email, Mobile Number,
            Date of birth, Gender &amp; Nationality.
          </li>{" "}
          <li>
            – <strong>For job creation:</strong> Basic details of the car (make,
            model, chassis number, km driven), Home address or location (in case
            of pick up drop service selection)
          </li>{" "}
        </ul>{" "}
        <p />{" "}
        <p>
          In addition, tracking information is collected as you navigate through
          our Platform, including, but not limited to geographic areas. If you
          are booking a job that involves pick up or drop via the Service, your
          GPS coordinates may be recorded. Most GPS enabled mobile devices can
          define one’s location to within 50 feet. We collect this information
          in order to calculate your pick-up drop charges, if any, and do not
          use it for any other purpose.
        </p>{" "}
        <p />{" "}
        <p>
          To help us serve your needs better, we use “cookies” to store and
          sometimes track user information. A cookie is a small amount of data
          that is sent to your browser from a web server and take a small space
          on your computer’s hard drive. Cookies can be disabled or controlled
          by setting a preference within your web browser. The use of third
          party cookies is not covered by our privacy policy. We do not have
          access or control over these cookies.
        </p>{" "}
        <p />{" "}
        <p>
          You may also choose to upload photos while using our Platform, if you
          wish to do so this may be viewable by the Service Providers for better
          experience. You may update your profile picture at any time by logging
          into your account and the pictures you shared with Service Provider on
          messaging service will be automatically removed after 30 days of job/
          purchase closure. When you use our services through your mobile
          device, we will track your geo-location information so that you are
          able to view the service providers nearest to your area, set your car
          location, and allow pick-up/ delivery boys to find your location. We
          will not share this information with third parties for any purpose and
          will only use this information for the sole purpose of fulfilling your
          request.
        </p>{" "}
        <p />{" "}
        <p>
          All credit/debit cards details and personally identifiable information
          will NEVER be stored or leased to any third parties without your
          additional permission. By submitting your credit or debit card account
          information through our Services, you expressly consent to the sharing
          of your information with third-party payment processors, and other
          third-party service providers (including but not limited to vendors
          who provide fraud detection services to us and other third parties).
        </p>{" "}
        <p />{" "}
        <p>
          Some of the advertisements you may see on the Site are selected and
          delivered by third parties, such as ad networks, advertising agencies,
          advertisers, and audience segment providers. These third parties may
          collect information about you and your online activities, either on
          the Site or on other websites, through cookies, web beacons, and other
          technologies in an effort to understand your interests and deliver to
          you advertisements that are tailored to your interests. Please
          remember that we do not have access to, or control over, the
          information these third parties may collect. The information practices
          of these third parties are not covered by this privacy policy.
        </p>{" "}
        <p />{" "}
        <p>
          You also may provide information (such as ratings, reviews, tips,
          comments, likes etc) to be published or displayed on publicly
          accessible areas of our Services, or transmitted to other users of our
          Services or thirdparties. Such information is posted on and
          transmitted to others at your own risk. Additionally, we cannot
          control the actions of other users of our Services with whom you may
          choose to share your information. Therefore, we cannot and do not
          guarantee that your information will not be viewed by unauthorized
          persons. We may display this information on the Services, share it
          with businesses, and further distribute it to a wider audience through
          third party sites and services. You should be careful about revealing
          any sensitive details about yourself in such postings.
        </p>{" "}
        <p />{" "}
        <p>
          The Company can use your Internet Protocol (IP) address to help
          diagnose problems with our computer server, and to administer the
          Website. Your IP address is used to help identify you, and to gather
          broad demographic data. Your IP address contains no personal
          information about you. We might also collect device type when you use
          our mobile application, we use this information for the sole purpose
          of providing you with the most up to date application and features.
        </p>{" "}
        <p />{" "}
        <p>
          <strong>How We Use Your Information</strong>
        </p>{" "}
        <p />{" "}
        <p>
          Our primary goal in collecting information is to provide you with an
          enhanced experience when using the Service. We use this information to
          closely monitor: (1) which features of the Platform are used most, (2)
          to allow you to view your Open Bonnet Service History, (3) store your
          credit card information with our PCI certified payment partner (upon
          permission), (4) get customized results for marketplace searches or
          promotions we may run from time to time in conjunction with Service
          Providers, (5) rate Service Providers, and (6) to determine which
          features we need to focus on improving, including usage patterns and
          geographic locations to determine where we should offer or focus
          services, features and/or resources. We use the mobile information
          collected so that we are able to serve you the correct app version
          depending on your device type, for troubleshooting and in some cases
          marketing purposes.
        </p>{" "}
        <p />{" "}
        <p>
          When you use Open Bonnet services, your information may be provided to
          the Service Providers whom you have selected. In order to facilitate
          your transaction, we provide your information to that Service Provider
          in a similar manner as if you had dealt directly with them. OBT or the
          Service Provider may contact you through calls or text messages
          regarding your job/ product purchases. We may also share with the
          Service Providers additional information, such as information about
          your car upkeep preferences and history or information that we collect
          from third-parties. We do not control the privacy practices of Service
          Providers. Please contact them directly if you want to learn about
          their privacy practices.
        </p>{" "}
        <p />{" "}
        <p>
          <strong>Service-related Announcements</strong>
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          We will send you strictly service-related announcements on rare
          occasions when it is necessary to do so. For instance, if our service
          is temporarily suspended for maintenance, we might send you an email.
          Generally, you may not opt-out of these communications, which are not
          promotional in nature. If you do not wish to receive them, you have
          the option to deactivate your account.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          <strong>Customer Service</strong>
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          When you sign up for an account, you are opting in to receive emails
          from other Open Bonnet or Service Providers. Based upon the personally
          identifiable information you provide us, we or the chosen Service
          Providers may also communicate with you by email, in-app messages or
          telephone in response to your inquiries, to provide the services you
          request, and to manage your account.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          <strong>Targeted or Behavioral Advertising</strong>
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          Targeted advertising (also known as Behavioral Advertising) uses
          information collected on an individual’s web browsing behavior such as
          the pages they have visited or the searches they have made. This
          information is then used to select which advertisement should Open
          Bonnet be displaying to a particular individual on websites other than{" "}
          <a href="https://www.openbonnet.com/">www.openbonnet.com</a> The
          information collected is only linked to an anonymous cookie ID
          (alphanumeric number); it does not include any information that could
          be linked back to a particular person, such as their name, address or
          credit card number.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          <strong>Our Disclosure of Your Information</strong>
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          We do not sell, rent or trade your personal information or
          geo-location information. We will only use this information as
          disclosed within this privacy policy.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          The Company may share aggregated information that includes
          non-identifying information and log data with third parties for
          industry analysis, demographic profiling and to deliver targeted
          advertising about other products and services.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          We may employ third party companies and individuals to facilitate our
          Service, to provide the Service on our behalf, to process payment,
          provide customer support, provide geo-location information to our
          service providers, to host our Platform, to perform Website-related
          services (e.g., without limitation, maintenance services, database
          management, web analytics and improvement of the Website’s features)
          or to assist us in analyzing how our Website and Service are used.
          These third parties have access to your personal information only to
          perform these tasks on our behalf and are obligated not to disclose or
          use it for any other purpose. We may also provide selected personal
          information to our trusted business partners or other trusted entities
          for the purpose of providing you with information on goods or services
          we believe will be of interest to you. You can, at any time, opt out
          of receiving such communications by contacting those third parties
          directly.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          The Company cooperates with government and law enforcement officials
          and private parties to enforce and comply with the law. We will
          disclose any information about you to government or law enforcement
          officials or private parties as we, in our sole discretion, believe
          necessary or appropriate to respond to claims and legal process
          (including but not limited to subpoenas), to protect the property and
          rights of the Company or a third party, to protect the safety of the
          public or any person, or to prevent or stop activity we may consider
          to be, or to pose a risk of being, an illegal, unethical or legally
          actionable activity.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          If we are involved in a merger, acquisition, or sale of Open Bonnet,
          you will be notified via email about the relevant changes particularly
          to the use of your personal information, as well as any choices you
          may have regarding your personal information.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          We may use a third party hosting provider to host our support section
          of the Platform. Information collected within this section is governed
          by our privacy policy.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          <strong>Access to Personal Information</strong>
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          If your personal information changes, you may correct, delete
          inaccuracies, or amend it by making the change on our profile page on
          the Application. We will retain your information (including
          geo-location) for as long as your account is active or as needed to
          provide you services. If you wish that we no longer use your
          information to provide you services contact us at{" "}
          <a href="mailto:support@openbonnet.com">user@openbonnet.com.</a>We
          will retain and use your information as necessary to comply with our
          legal obligations, resolve disputes, and enforce our agreements.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          Users under 18 years age: The Services are not intended for users
          under the age of 18. We do not knowingly collect any personal
          information from users under 18 or market to or solicit information
          from anyone under the age of 18. If we become aware that a person
          submitting personal information is under 18, we will delete the
          account and any related information as soon as possible. If you
          believe we might have any information from or about an individual user
          under 18, please contact us at{" "}
          <a href="mailto:support@openbonnet.com">user@openbonnet.com</a>
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          <strong>Security</strong>
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          The personally identifiable and geo-location information we collect is
          securely stored within our database, and we use standard,
          industry-wide, commercially reasonable security practices such as
          encryption, firewalls and SSL (Secure Socket Layers) for protecting
          your information. However, as effective as encryption technology is,
          no security system is impenetrable. We cannot guarantee the security
          of our database, nor can we guarantee that information you supply
          won’t be intercepted while being transmitted to us over the Internet,
          and any information you transmit to the Company you do at your own
          risk. We recommend that you not disclose your password to anyone.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          Compliance with data protection regulations: The information we obtain
          from or about you may be processed and stored in various servers
          located across the globe, which may provide for different data
          protection rules than the country in which you reside. We comply with
          generally accepted industry standard regulations regarding the
          collection, use, and retention of data. Each location may provide for
          different data protection rules than the country in which you reside.
          By using the Services, you consent to the collection, transfer, use,
          storage and disclosure of your information as described in this
          Privacy Policy, including to the transfer of your information outside
          of your country of residence.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          <strong>Social Media (Features) and Widgets</strong>
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          Our Platform includes Social Media Features, such as the Facebook/
          LinkedIn/ Google login, Facebook Like button and Widgets, such as the
          Share this button or interactive mini-programs that run on our site.
          These features may collect your IP address, which page you are
          visiting on our site, and may set a cookie to enable the feature to
          function properly. Social Media Features and Widgets are either hosted
          by a third party or hosted directly on our Site. Your interactions
          with these Features are governed by the privacy policy of the company
          providing it.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          <strong>Changes in this Privacy Policy</strong>
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          The Platform Policies and Terms &amp; Conditions may be changed or
          updated occasionally to meet the requirements and standards. Therefore
          the Customers’ are encouraged to frequently visit these sections in
          order to be updated about the changes on the Platform. Modifications
          will be effective on the day they are posted.
        </p>{" "}
        <p />{" "}
        <p className="nitro-offscreen">
          <strong>
            For any queries related to the Privacy Policy, please contact us on:
            user@openbonnet.com
          </strong>
        </p>
      </Container>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    profile: state.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Terms);
